import { render } from "./Levensverhaal.vue?vue&type=template&id=0f6a746c&scoped=true"
import script from "./Levensverhaal.vue?vue&type=script&lang=js"
export * from "./Levensverhaal.vue?vue&type=script&lang=js"

import "./Levensverhaal.vue?vue&type=style&index=0&id=0f6a746c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6a746c"]])

export default __exports__